<div class="main">
  <div class="logo">
    <img src="assets/general/logo.png" />
    <p>بنتو</p>
  </div>
  <div class="message-box">
    <p>کد پیامک شده به {{ phoneNumber }} را وارد کنید.</p>
  </div>
  <div
    [ngClass]="
      activeButton && !hasError
        ? 'input-box active'
        : hasError
        ? 'input-box error'
        : 'input-box disable'
    "
  >
    <span class="input-focuse" *ngIf="!!isFocuse"> کد تایید </span>
    <img
      class="phone-image"
      *ngIf="!isFocuse"
      src="assets/authentication/phone.svg"
    />
    <input
      id="phoneInput"
      type="text"
      autocomplete="one-time-code"
      inputmode="numeric"
      [(ngModel)]="activationCode"
      [placeholder]="isFocuse ? '' : '*کد تایید را وارد کنید'"
      (ngModelChange)="activate()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      maxlength="4"
    />
    <div class="icons">
      <img
        *ngIf="activationCode && activationCode.split.length > 1 && !hasError"
        src="assets/authentication/close.svg"
        (click)="clearInput()"
        alt=""
      />
      <img
        *ngIf="hasError && !isFocuse"
        src="assets/authentication/error.svg"
        alt=""
      />
    </div>
  </div>
  <p class="require-message" *ngIf="!hasError">*این فیلد الزامی است.</p>
  <div *ngIf="hasError" class="error require-message">{{ errorMessage }}</div>

  <div class="send-again-counter" *ngIf="counter > 0">
    {{ counter }} ثانیه تا ارسال مجدد کد
  </div>
  <div class="send-again-button" *ngIf="counter <= 0" (click)="retrySMS()">
    ارسال مجدد کد فعالسازی
  </div>

  <!-- <div class="input-holder">
    <div
      [ngClass]="
        !hasError && activationCodes[i]
          ? 'input-box-' + i + ' active-border'
          : hasError
          ? 'input-box-' + i + ' error'
          : 'input-box-' + i + ' disable-border'
      "
      *ngFor="let element of counters; let i = index"
    >
      <input
        type="tel"
        [(ngModel)]="activationCodes[i]"
        placeholder=""
        (input)="activateButton(i)"
        (keyup)="keytab($event, i)"
        attr.id="input{{ i }}"
        maxlength="1"
      />
    </div>
  </div> -->

  <button
    class="login-button"
    [ngClass]="{ active: activeButton }"
    (click)="onLogin()"
  >
    ورود
  </button>
  <button class="change-number" (click)="backToPhoneNumberPage()">
    تغییر شماره همراه
  </button>
  <!-- <app-submit-button [title]="buttonTitle"></app-submit-button> -->
  <app-loading-spinner
    [isDone]="isDone"
    *ngIf="showLoading"
  ></app-loading-spinner>
</div>
